import { Coins } from "lucide-react";

export default function CoinBadge({ amount, size = "md" }) {
    const cls =
        size === "lg"
            ? "px-4 py-2 text-lg"
            : size === "sm"
              ? "px-2.5 py-1 text-xs"
              : "px-3 py-1.5 text-sm";
    return (
        <div
            className={`inline-flex items-center gap-2 rounded-full bg-[#FFF4D9] text-[#0A0A0A] font-semibold ${cls} border border-[#F5A623]/30`}
            data-testid="coin-badge"
        >
            <Coins size={size === "lg" ? 20 : 16} className="text-edu-gold" />
            <span>{amount ?? 0}</span>
        </div>
    );
}
